import { EyeOutlined } from "@ant-design/icons";
import { Button, Collapse, Table, Typography } from "antd";

import { useGetSignedAgreements } from "./api/useGetSignedAgreements";
import { AGREEMENT_KIND_LABELS, type AgreementKind } from "./types";

const { Text } = Typography;

interface WorkerSignedAgreementsSectionProps {
  workerId: string;
}

export function WorkerSignedAgreementsSection({ workerId }: WorkerSignedAgreementsSectionProps) {
  const { data: signedAgreements, isLoading } = useGetSignedAgreements({
    workerId,
  });

  return (
    <Collapse>
      <Collapse.Panel key="signedAgreementsTable" header="Signed Legal Agreements">
        <Table
          columns={[
            {
              title: "Type",
              dataIndex: ["attributes", "kind"],
              key: "type",
              render: (kind: AgreementKind) => <Text>{AGREEMENT_KIND_LABELS[kind] ?? kind}</Text>,
            },
            {
              title: "Version",
              dataIndex: ["attributes", "version"],
              key: "version",
            },
            {
              title: "Signed At",
              dataIndex: ["attributes", "signedAt"],
              key: "signedAt",
              render: (signedAt: string) => <Text>{new Date(signedAt).toISOString()}</Text>,
            },
            {
              title: "PDF",
              key: "pdf",
              render: (_, record) => {
                const { downloadUrl } = record.attributes;
                return downloadUrl ? (
                  <Button icon={<EyeOutlined />} onClick={() => window.open(downloadUrl, "_blank")}>
                    View
                  </Button>
                ) : (
                  <Text type="secondary">PDF not available</Text>
                );
              },
            },
          ]}
          dataSource={signedAgreements?.data}
          loading={isLoading}
          rowKey="id"
          pagination={{ hideOnSinglePage: true, showSizeChanger: false }}
        />
      </Collapse.Panel>
    </Collapse>
  );
}
